import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';
import RouteDetailMap from '../components/RouteDetailMap.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import i18n from '../locales';
import axios from 'axios';
import showConfirmation from '@waypoint/vue-confirmation';

import motivesAndSubmotivesEscl from '../locales/es-CL/motivesAndSubmotives.json';
import motivesAndSubmotivesEsmx from '../locales/es-MX/motivesAndSubmotives.json';
import motivesAndSubmotivesEsco from '../locales/es-CO/motivesAndSubmotives.json';
import motivesAndSubmotivesEnus from '../locales/en-US/motivesAndSubmotives.json';

import routeBoardEscl from '../locales/es-CL/routeBoard.json';
import routeBoardEsmx from '../locales/es-MX/routeBoard.json';
import routeBoardEsco from '../locales/es-CO/routeBoard.json';
import routeBoardEnus from '../locales/en-US/routeBoard.json';

export default {
  name: 'MotivesAndSubmotives',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
    GoogleMapsApiLoader,
    RouteDetailMap,
  },
  data() {
    return {
      crudState: 'createMotive',
      selectedStatus: null,
      selectedMotive: null,
      motive: {
        id: null,
        name: null,
      },
      submotive: {
        id: null,
        name: null,
      },
      isSaving: false,
      newMotive: null,
      statusList: [],
      currentMotiveList: [],
      dataAccess: null,
      isBusy: false,
      pageOptions: [10, 15, 20, 50, 100],
      perPage: 10,
      currentPage: 1,
      opened: [],
      isBasicUser: false,
    };
  },
  mounted() {
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      motivesAndSubmotives: motivesAndSubmotivesEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      motivesAndSubmotives: motivesAndSubmotivesEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      motivesAndSubmotives: motivesAndSubmotivesEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      motivesAndSubmotives: motivesAndSubmotivesEnus,
    });

    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      routeBoard: routeBoardEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      routeBoard: routeBoardEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      routeBoard: routeBoardEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      routeBoard: routeBoardEnus,
    });
  },
  async created() {
    this.prepareData();
  },
  methods: {
    checkForm() {
      var validateResult = false;
      validateResult = this.validateFields();
      if (validateResult) {
        this.saveManager();
      }
    },
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      this.isBasicUser = this.$store.getters.isBasicUser;
      this.getStatus();
    },
    manageMotive(crudStateTemp, data) {
      this.crudState = crudStateTemp;
      if (data != null) {
        if (this.crudState === 'createMotive') {
          this.selectedStatus = this.statusList.find((element) => element.statusId === data.statusId);
          this.openModal('modal-motive');
        }
        if (this.crudState === 'editMotive') {
          this.selectedStatus = this.statusList.find((element) => element.statusId === data.idStatus);
          this.motive.id = data.id;
          this.motive.name = data.name;
          this.openModal('modal-motive');
        }
        if (this.crudState === 'deleteMotive') {
          showConfirmation(
            this.$t('common.modals.confirmacionTitulo'),
            this.$t('motivesAndSubmotives.modal.confirmDeleteMotive', {
              motiveName: data.name,
            }),
            () => {
              this.selectedStatus = this.statusList.find((element) => element.statusId === data.idStatus);
              this.motive.id = data.id;
              this.saveManager();
            },
            this.$t('common.cruds.aceptar'),
            this.$t('common.cruds.cerrar'),
          );
        }
        if (this.crudState === 'createSubmotive') {
          this.selectedStatus = this.statusList.find((element) => element.statusId === data.idStatus);
          this.currentMotiveList = this.selectedStatus.motiveList;
          this.selectedMotive = this.selectedStatus.motiveList.find((motive) => motive.id === data.id);
          this.openModal('modal-motive');
        }
        if (this.crudState === 'editSubmotive') {
          this.selectedStatus = this.statusList.find((element) => element.statusId === data.idStatus);
          this.selectedMotive = this.selectedStatus.motiveList.find((motive) => motive.id === data.idMotive);
          this.submotive.id = data.id;
          this.submotive.name = data.name;
          this.openModal('modal-motive');
        }
        if (this.crudState === 'deleteSubmotive') {
          showConfirmation(
            this.$t('common.modals.confirmacionTitulo'),
            this.$t('motivesAndSubmotives.modal.confirmDeleteSubmotive', {
              submotiveName: data.name,
            }),
            () => {
              this.selectedStatus = this.statusList.find((element) => element.statusId === data.idStatus);
              this.motive.id = data.idMotive;
              this.submotive.id = data.id;
              this.saveManager();
            },
            this.$t('common.cruds.aceptar'),
            this.$t('common.cruds.cerrar'),
          );
        }
      } else {
        if (this.crudState === 'createMotive') {
          this.openModal('modal-motive');
        }
        if (this.crudState === 'createSubmotive') {
          this.openModal('modal-motive');
        }
      }
    },
    updateMotiveList() {
      if (
        (this.crudState === 'createSubmotive' || this.crudState === 'editSubmotive') &&
        this.currentMotiveList != null &&
        this.selectedStatus != null
      ) {
        this.selectedMotive = null;
        this.currentMotiveList = this.selectedStatus.motiveList;
      }
    },
    openModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    cleanModalInfo() {
      this.selectedStatus = null;
      this.motive.id = null;
      this.motive.name = null;
      this.submotive.id = null;
      this.submotive.name = null;
      this.currentMotiveList = [];
      this.selectedMotive = null;
    },
    async saveManager() {
      this.isSaving = true;
      let validateResult = false;
      if (this.crudState === 'createMotive') {
        validateResult = this.validateFields();
        if (validateResult) {
          const motive = await this.createMotive();
          if (motive != null) {
            //Se añade el motivo
            const status = this.statusList.find((status) => status.statusId === motive.idStatus);
            //Se suma uno al total de motivos
            status.motives += 1;
            status.motiveList.unshift(motive);
          }
        }
      }
      if (this.crudState === 'editMotive') {
        validateResult = this.validateFields();
        if (validateResult) {
          const motive = await this.editMotive();
          if (motive != null) {
            const status = this.statusList.find((status) => status.statusId === motive.idStatus);
            status.motiveList.find((statusMotive) => {
              if (statusMotive.id == motive.id) {
                //Se edita el nombre del motivo
                statusMotive.name = motive.name;
                return statusMotive;
              }
            });
          }
        }
      }
      if (this.crudState === 'deleteMotive') {
        validateResult = await this.deleteMotive();
        if (validateResult) {
          console.log(this.selectedStatus);
          const status = this.statusList.find((status) => status.statusId === this.selectedStatus.statusId);
          const indice = status.motiveList.findIndex((m) => m.id == this.motive.id);
          if (indice >= 0) {
            const totalSubmotive = status.motiveList[indice].subMotive.length;
            //Se elimina el motivo
            status.motiveList.splice(indice, 1);
            //Se disminuye el contador de motivos y submotivos del estado
            status.motives -= 1;
            status.subMotives -= totalSubmotive;
          }
        }
      }
      if (this.crudState === 'createSubmotive') {
        validateResult = this.validateFields();
        if (validateResult) {
          const submotive = await this.createSubmotive();
          if (submotive !== null) {
            const status = this.statusList.find((status) => status.statusId === this.selectedStatus.statusId);
            //Se aumenta el contador de submotivos
            status.subMotives += 1;
            const motive = status.motiveList.find((statusMotive) => statusMotive.id === this.selectedMotive.id);
            //Se añade el submotivo creado
            motive.subMotive.push({
              ...submotive,
              idStatus: motive.idStatus,
            });
          }
        }
      }
      if (this.crudState === 'editSubmotive') {
        validateResult = this.validateFields();
        if (validateResult) {
          const submotive = await this.editSubmotive();
          if (submotive !== null) {
            const status = this.statusList.find((status) => status.statusId === this.selectedStatus.statusId);
            const motive = status.motiveList.find((statusMotive) => statusMotive.id === this.selectedMotive.id);
            motive.subMotive.find((mSubmotive) => {
              //Actualizo el submotivo en el listado
              if (mSubmotive.id == submotive.id) {
                mSubmotive.name = submotive.name;
                mSubmotive.idMotive = motive.id;
                mSubmotive.idStatus = motive.idStatus;
                return mSubmotive;
              }
            });
          }
        }
      }
      if (this.crudState === 'deleteSubmotive') {
        validateResult = await this.deleteSubmotive();
        if (validateResult) {
          const status = this.statusList.find((status) => status.statusId === this.selectedStatus.statusId);
          const motive = status.motiveList.find((m) => m.id == this.motive.id);
          const indice = motive.subMotive.findIndex((s) => s.id == this.submotive.id);
          if (indice >= 0) {
            motive.subMotive.splice(indice, 1);
            status.subMotives -= 1;
          }
        }
      }
      this.isSaving = false;
      if (validateResult) {
        this.openModal('modal-success');
        this.cleanModalInfo();
        this.closeModal('modal-motive');
      } else {
        this.openModal('modal-fail');
      }
    },
    validateFields() {
      if (this.crudState === 'createMotive' || this.crudState === 'editMotive') {
        if (!this.selectedStatus) {
          this.showPopover('fldIdStatus');
          return false;
        }
        if (!this.motive.name) {
          this.showPopover('fldMotiveName');
          return false;
        }
        return true;
      }
      if (this.crudState === 'createSubmotive' || this.crudState === 'editSubmotive') {
        if (!this.selectedStatus) {
          this.showPopover('fldIdStatus');
          return false;
        }
        if (!this.selectedMotive) {
          this.showPopover('fldMotiveList');
          return false;
        }
        if (!this.submotive.name) {
          this.showPopover('fldSubmotiveName');
          return false;
        }
        return true;
      }
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
      }
    },
    async createMotive() {
      const url = `${this.$store.getters.urlAPI}/motive`;
      const body = {
        idStatus: this.selectedStatus.statusId,
        name: this.motive.name.toUpperCase(),
        description: null,
        subMotive: [],
      };

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, body, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async editMotive() {
      const url = `${this.$store.getters.urlAPI}/motive/${this.motive.id}`;
      const body = {
        idStatus: this.selectedStatus.statusId,
        name: this.motive.name.toUpperCase(),
        description: null,
        subMotive: null,
      };

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.patch(url, body, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async deleteMotive() {
      const url = `${this.$store.getters.urlAPI}/motive/${this.motive.id}`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        await axios.delete(url, config);
        return true;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async createSubmotive() {
      const url = `${this.$store.getters.urlAPI}/submotive`;
      const body = {
        idMotive: this.selectedMotive.id,
        name: this.submotive.name.toUpperCase(),
        description: null,
      };
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, body, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async editSubmotive() {
      const url = `${this.$store.getters.urlAPI}/submotive/${this.submotive.id}`;
      const body = {
        idMotive: this.submotive.idMotive,
        name: this.submotive.name.toUpperCase(),
        description: null,
      };
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.patch(url, body, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async deleteSubmotive() {
      const url = `${this.$store.getters.urlAPI}/submotive/${this.submotive.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        await axios.delete(url, config);
        return true;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async getStatus() {
      this.statusList = [];
      this.isBusy = true;
      const url = `${this.$store.getters.urlAPI}/status`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const statusPromise = await axios.get(url, config);
        console.log(statusPromise.data.data);
        if (this.dataAccess.canNavMotive) {
          statusPromise.data.data.forEach((element) => {
            if (element.nemo === 'PARTIALLYDONE' || element.nemo === 'NOTDONE') {
              const motiveSize = element.motive.length;
              let subMotiveSize = 0;
              element.motive.forEach((motiveElement) => {
                subMotiveSize += motiveElement.subMotive.length;
              });
              element.motive.forEach((motiveTemp) => {
                motiveTemp.idStatus = element.id;
                motiveTemp.subMotive.forEach((submotiveTemp) => {
                  submotiveTemp.idMotive = motiveTemp.id;
                  submotiveTemp.idStatus = motiveTemp.idStatus;
                });
              });
              this.statusList.push({
                statusId: element.id,
                statusName: element.name,
                motives: motiveSize,
                subMotives: subMotiveSize,
                motiveList: element.motive,
              });
            }
          });
        } else {
          statusPromise.data.data.forEach((element) => {
            if (element.nemo === 'PARTIALLYDONE' || element.nemo === 'NOTDONE') {
              const motiveSize = element.motive.length;
              let subMotiveSize = 0;
              element.motive.forEach((motiveElement) => {
                subMotiveSize += motiveElement.subMotive.length;
              });
              element.motive.forEach((motiveTemp) => {
                motiveTemp.idStatus = element.id;
                motiveTemp.subMotive.forEach((submotiveTemp) => {
                  submotiveTemp.idMotive = motiveTemp.id;
                  submotiveTemp.idStatus = motiveTemp.idStatus;
                });
              });
              this.statusList.push({
                statusId: element.id,
                statusName: element.name,
                motives: motiveSize,
                subMotives: subMotiveSize,
                motiveList: element.motive,
              });
            }
          });
        }
      } catch (e) {
        console.log(e);
        this.statusList = [];
      }
      this.isBusy = false;
    },
    /**
     * Metodo que deriva a otra vista dado ciertos parametros.
     * Prioridad al cambiar de vista: Preparar filtrado instantaneo por id de ruta.
     * @param {Integer} routeId, es la id de la ruta seleccionada.
     * @param {String} path, es el nombre de la vista a la que se desea ir.
     * @returns A la nueva vista.
     */
    async goToAnotherPage(routeId, path) {
      this.isButtonClicked = true;
      await this.$store.commit('saveShortCutPathOrigin', 'Route fulfillment');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },
    async handlePageChange() {
      await this.getStatus();
    },
    /**
     * Metodo que retorna a la vista anterior.
     * @param {String} shortCutPath, nombre de la ruta.
     * @returns vista anterior.
     */
    returnToPage(shortCutPath) {
      return this.$router.push({ name: shortCutPath });
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
  },
  computed: {
    rows() {
      return this.statusList.length;
    },
    fromManagement() {
      return !!this.$route.query.fromManagement;
    },
    statusFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'expander',
          tdClass: 'text-left',
          label: '',
          ...common,
        },
        {
          key: 'statusName',
          label: this.$t('motivesAndSubmotives.table.statusName'),
          ...common,
        },
        {
          key: 'motives',
          tdClass: 'text-center',
          label: this.$t('motivesAndSubmotives.table.motives'),
          ...common,
        },
        {
          key: 'subMotives',
          tdClass: 'text-center',
          label: this.$t('motivesAndSubmotives.table.subMotives'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('motivesAndSubmotives.table.actions'),
          ...common,
        },
      ];
    },
    motivesFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'expander2',
          tdClass: 'text-left',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: 'namee',
          tdClass: 'text-center',
          ...common,
        },
        {
          key: 'subMotive',
          label: 'submotivoo',
          tdClass: 'text-center',
          ...common,
        },
        {
          key: 'actions',
          label: 'actions',
          ...common,
        },
      ];
    },
  },
};
